(function () {
    'use strict';

    angular
        .module('ib-speqs-module')
        .directive('deleteTooltip', deleteTooltip);

    deleteTooltip.$inject = [];
    function deleteTooltip () {

        const directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link (scope, element, attrs) {
            angular.element(element).mouseout(() => {
                if (angular.element('#tooltipHover').length > 0) {
                    angular.element('#tooltipHover').remove();
                }
            });
        }
    }

})();